import moment from 'moment';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { commas } from '../../methods/utils/general-utils';

interface IFixedSavingsItem {
	item: any;
}

const Style = styled.div`
	margin-bottom: 10px;
	padding: 12px;
	background-color: #f8f8f8;

	& .amount {
		font-size: 18px;
	}

	& .title > * {
		display: inline-block;
	}

	& .details {
		margin-top: 10px;
		border-top: 1px dashed #ccc;
		font-size: 14px;
		font-style: italic;

		& .label {
			color: #aaa;
			font-size: 12px;
			font-style: italic;
		}

		& > * {
			display: inline-block;
			padding: 10px;
		}
	}
`;

const FixedSavingsItem = ({ item }: IFixedSavingsItem) => (
	<Style>
		<div>
			<p className="amount">
				{commas(item.depositAmount)} {item.currencyId?.symbol}
			</p>
			<div className="title">
				<Link
					to={`/core-modules/fixed-savings/single/${item.fixedSavingsId?._id}`}
					title="View Savings Profile"
				>
					{item.fixedSavingsId?.title} ({item.currencyId?.symbol})
				</Link>
			</div>
		</div>
		<div className="details">
			<div>
				<Link
					title="View Customer Profile"
					to={`/user-profile/${item.userId?._id}`}
				>
					@{item.userId?.username}
				</Link>
				<p className="label">Customer</p>
			</div>
			<div>
				<p>{item.status}</p>
				<p className="label">Status</p>
			</div>
			<div>
				<p>{item.itemForm}</p>
				<p className="label">Item Form</p>
			</div>
			<div>
				<p>{moment(item.startDate).format('MMM DD, YY / hh:mm:ss a')}</p>
				<p className="label">Starts</p>
			</div>
			<div>
				<p>{moment(item.endDate).format('MMM DD, YY / hh:mm:ss a')}</p>
				<p className="label">Ends</p>
			</div>
			<div>
				<p>{item.durationDays} days</p>
				<p className="label">Duration</p>
			</div>
			<div>
				<a
					href={`https://${item.blockchainTransactionHash}`}
					target="_blank"
					rel="noreferrer"
				>
					Hash
				</a>
				<p className="label">Transaction Hash</p>
			</div>
			<div>
				<p>
					{commas(item.fixedSavingsFees?.fee)} {item.currencyId?.symbol}
				</p>
				<p className="label">Fee</p>
			</div>
			<div>
				<p>
					{item.countryCode} | {item.deviceType}
				</p>
				<p className="label">Country | Device</p>
			</div>
			<div>
				<p>View Transaction</p>
				<p className="label">Transaction</p>
			</div>
			<div>
				<p>{moment(item.createdAt).format('MMM DD, YY / hh:mm:ss a')}</p>
				<p className="label">Created At</p>
			</div>
			<div>
				<p>{moment(item.updatedAt).format('MMM DD, YY / hh:mm:ss a')}</p>
				<p className="label">Updated At</p>
			</div>
		</div>
	</Style>
);

export default FixedSavingsItem;
